<template>

  <!--父组件-->

  <view>
    <cxAdudioPlay
	  :list='list'
      :BsNav="BsNav"
      :autoplays="true"
      :slideYes="true"
      :autoNext="true"
      :switAud="true"
    ></cxAdudioPlay>
  </view>
</template>
<script>

import cxAdudioPlay from "../../components/audioPlay/audioPlay.vue";

export default {

  components: {
    cxAdudioPlay,
  },
  data() {
    return {
      mp3_path:'',
      list: [
        //音频文件
        {
          recorPath:
            "../../static/mp3/5527.mp3",
		  name:'老虎叫'
        },
		{
		  recorPath:
		    "../../static/mp3/5527.mp3",
		  name:'老虎叫'
		},
		{
		  recorPath:
		    "../../static/mp3/5527.mp3",
		  name:'老虎叫'
		}
      ],
      BsNav: [
        //倍数-自定义
        {
          id: 1.0,
          bs: "1.0",
        },
        {
          id: 1.5,
          bs: "1.5",
        },
        {
          id: 2.0,
          bs: "2.0",
        },{
          id: 2.5,
          bs: "2.5",
        },{
          id: 3.0,
          bs: "3.0",
        },
      ],
    };
  },
  onLoad(options) {
	console.log(options)
	this.mp3_path = '../../static/listen_read4/'+options.title+'.wav'
	this.list[0].recorPath = this.mp3_path
	this.list[0].name = options.title
	console.log(this.list)
  },
  methods: {},
};
</script>
<style>
</style>